import { useEffect, useRef, useState } from 'react';

export function useAudioPlayer(
  src: string,
  isPlaying: boolean,
  onStop: () => void,
) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  // Sync play/pause with external isPlaying flag
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.play().catch(() => onStop());
    } else {
      audio.pause();
    }
  }, [isPlaying, onStop]);

  const seek = (time: number) => {
    setCurrentTime(time);
    if (audioRef.current) audioRef.current.currentTime = time;
  };

  const safeDuration = Number.isFinite(duration) ? duration : 0;
  const progressPercent =
    safeDuration > 0 ? (currentTime / safeDuration) * 100 : 0;

  return {
    audioRef,
    currentTime,
    duration: safeDuration,
    progressPercent,
    seek,
    onLoadedMetadata: (e: React.SyntheticEvent<HTMLAudioElement>) => {
      const d = e.currentTarget.duration;
      setDuration(Number.isFinite(d) ? d : 0);
    },
    onTimeUpdate: (e: React.SyntheticEvent<HTMLAudioElement>) => {
      setCurrentTime(e.currentTarget.currentTime);
    },
    onEnded: () => {
      setCurrentTime(0);
      onStop();
    },
  };
}
